import {
  GET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
  IS_GRID_LOADING,
  SET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
} from "./AssetAuditResetHistoryLogTypes";

const getAssetAuditHistoryLogGridData = (payload: any) => ({
  type: GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
  payload,
});

const setAssetAuditHistoryLogGridData = (gridData: any) => ({
  type: SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
  gridData,
});

const getAssetAuditHistoryExcelData = (auditResetId: any) => ({
  type: GET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  auditResetId,
});

const setAssetAuditHistoryExcelData = (excelData: any) => ({
  type: SET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  excelData,
});

const setIsGridLoading = (flag: any) => ({
  type: IS_GRID_LOADING,
  flag
});


export {
    getAssetAuditHistoryLogGridData,
    setAssetAuditHistoryLogGridData,
    getAssetAuditHistoryExcelData,
    setAssetAuditHistoryExcelData,
    setIsGridLoading
}